// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ks-0";
export var discountCodeInput = "_ks-1";